
var isLoggingEnabled = process.env.REACT_APP_LOGGING_STATUS

var logger = function logger(...messages){
    if(process.env.NODE_ENV === isLoggingEnabled){
        logger(messages);
    }
}  
export default logger;